// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"7474":"4c25a524","9821":"29887c6d"}[chunkId] + ".css";
};